import React, {useEffect, useMemo, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {Table, TextLink, ImageStamp} from "../../../components";
import {elderResidencesAction} from "redux/actions";
import {useHistory} from "react-router-dom";
import UpdateHomeIdModel from "../../MemberProfile/modals/UpdateHomeIdModel";
import {Modal} from "@material-ui/core";

function EldResidencesTab({clickedElder, handleCloseModal, setClickedSubscription, handleOpenSubscriptionModal}) {
    const {
        push
    } = useHistory();

    const [tableRows, setTableRows] = useState();

    // Redux actions
    const dispatch = useDispatch();
    const datas = useSelector(state => state.elderResidences);
    const [openModalUHID, setOpenModalUHID] = useState(false);
    const [currentSubID, setCurrentSubID] = useState(null)
    const [refreshPage, setRefreshPage] = useState(null)
    const handleOpenModalUHID = () => {
        setOpenModalUHID(true)
    }
    const handleCloseUHID = () => {
        setOpenModalUHID(false)
    }

    useEffect(() => {
        dispatch(elderResidencesAction.get(clickedElder?.id));
        return () => dispatch(elderResidencesAction.reset());
    }, [refreshPage]);

    useEffect(() => {
        let filtered = datas;
        if (!filtered?.length) {
            setTableRows();
            return;
        }

        // Map table rows
        const data = filtered?.map(obj => ({
            id: obj?.residence_id,
            elder_id: obj?.elder_id,
            home_id: obj?.home_id,
            picture: <ImageStamp src={obj?.photo_url}/>,
            address: (
                <TextLink
                    text={obj?.address_line1 + ', ' +obj?.address_line2}
                    onClick={() =>
                        window.open(
                            `https://www.google.com/maps/search/?api=1&query=${obj?.address_line1}, ${obj?.address_line2}`,
                            "_blank"
                        )
                    }
                    style={{width:"200px !important"}}
                />
            ),
            city: obj?.city,
            state: obj?.state,
            postal_code: obj?.postal_code,
            country: obj?.country,
            createdAt: `${new Date(obj?.created_at).toLocaleString()}`,
            updatedAt: `${new Date(obj?.updated_at).toLocaleString()}`,
            action:<> <button
                        className={"btn btn-primary w-75 btn-primary"}
                        onClick={() => {
                            handleOpenModalUHID(true);
                            setCurrentSubID(obj.residence_id);
                            // alert('Update Home Id');
                        }}
                        style={{textTransform: 'capitalize', minWidth: "106px", fontSize: "12px", marginBottom: "5px", padding: "0px"}}>
                        Update Home ID
                    </button>
                    
                </>,
        }));

        setTableRows(data);
    }, [datas]);

    // Table Header
    const tableHeaders = useMemo(
        () => [
            {
                title: "Residence ID"
            },
            {
                title: "Elder"
            },
            {
                title: "Home Id"
            },
            {
                title: "Picture"
            },
            {
                title: "Address" 
            },
            {
                title: "City"
            },
            {
                title: "State"
            },
            {
                title: "Postal Code"
            },
            {
                title: "Country"
            },
            {
                title: "Created"
            },
            {
                title: "Updated"
            },
            {
                title: "Action"
            }
        ],
        [tableRows]
    );

    return (
        <div className='elder_residence'>
            <Table
                headers={tableHeaders}
                data={tableRows}
                current={datas?.currentPage}
                totalPage={datas?.maxPages}
            />

            <Modal
                open={openModalUHID}
                onClose={handleCloseUHID}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <UpdateHomeIdModel tableRows={datas} handleCloseUHID={handleCloseUHID} currentSubID={currentSubID} setRefreshPage={setRefreshPage} />
            </Modal>
        </div>
    );
}

export default EldResidencesTab;